import { computed } from 'vue';
import { SummaryInfo } from '@/api/tracking';
import {
  FeedSummaryFeature,
  FeedSummaryResponse,
  SummarizableFeature,
  SurveyHistoryStatus,
} from '@/types';
import { parseModelResponse } from '@/utils/survey/common';

export const useFeedSummaryContent = (props: {
  feedSummary: FeedSummaryResponse;
  feature: SummarizableFeature;
  themeId?: number;
}) => {
  const summaryFeature = computed<FeedSummaryFeature>(() => {
    return `${props.feature}_summary`;
  });

  const contentParts = computed(() => {
    if (props.feedSummary.generation_status === 'processed') {
      return parseModelResponse(
        props.feedSummary.model_response,
        props.feedSummary.sources,
        false,
        false,
      );
    }
    return [];
  });

  const status = computed<SurveyHistoryStatus>(() => {
    const isInProgress = props.feedSummary.generation_status !== 'processed';
    const isNoHit = false;
    const isError = props.feedSummary.generation_status === 'error';
    const errorCause =
      props.feedSummary.generation_status === 'error'
        ? props.feedSummary.error_message
        : undefined;
    const progressMessage = '';

    return {
      isInProgress,
      isNoHit,
      isError,
      errorCause,
      progressMessage,
    };
  });

  const summaryInfo = computed<SummaryInfo | undefined>(() => {
    if (props.feedSummary.generation_status === 'unprocessed') return undefined;

    // テーマ要約
    if (props.themeId !== undefined) {
      return {
        theme_summary: { id: props.feedSummary.id },
        theme: { id: props.themeId },
      };
    }
    // パーソナルニュース要約
    return {
      personal_feed_summary: { id: props.feedSummary.id },
    };
  });

  return {
    summaryFeature,
    contentParts,
    status,
    summaryInfo,
  };
};
